export const NEMA_LOGO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_983ac503-d34a-4b6b-be77-9bea654721c1/artifacts/js0mzwnq_NEMA%20TV%20%281%29-min.png";

export const NEMA_APP_ICON =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_983ac503-d34a-4b6b-be77-9bea654721c1/artifacts/4iu1plge_2024-08-02_23-51-08.png";
